import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import { MapQueryResultSet } from 'tivigi/src/util/mapQueryUtil';
import CollapsibleFeaturesList from 'tivigi/src/components/gis/CollapsibleFeaturesList/CollapsibleFeaturesList'
import * as ol from 'ol/'
import * as ol_source from 'ol/source'
import * as ol_layer from 'ol/layer'
import { FeatureLike } from 'ol/Feature';


import './IsochroneInfoPanel.scss'
import WithRender from './IsochroneInfoPanel.html';


@WithRender
@Component({ components: {
    CollapsibleFeaturesList
} })


export default class IsochroneInfoPanel extends Vue {
    @Prop()
    isochroneFeature!: ol.Feature

    @Prop()
    map!:ol.Map

    resultset = new MapQueryResultSet()

    get NumFeatures(){

        if(this.resultset.numFeatures()>0){
            return false
        }
        else{
            return true
        }
    }


    isoChroneActive:boolean = false


    @Watch('isochroneFeature', {deep:true})
    onChange()
    {   

        if(this.isochroneFeature != undefined){
            this.init()
            this.map.getLayers().on('add', this.onLayerAdd)
            this.map.getLayers().on('remove', this.onLayerRemove)
        }
    }

    getNumFeatures(){

        let infoText: string = ""

        let numLayer: number = this.resultset.entries.length

        let  counter: number = 1

        for(let entry of this.resultset.entries){

            let layerTitle: string = entry.layer.get('title')
            let numFeatures: number = entry.features.length

            if(numFeatures == 1){
                infoText += numFeatures.toString() + " x " + layerTitle
            }
            else{
                infoText += numFeatures.toString() + " x " + layerTitle

            }


            if(counter == numLayer-1){
                infoText += " und "
            }
            else if(counter == numLayer){
                continue
            }
            else{
                infoText += ', '
            }

            counter += 1
        }

        return infoText
    }

    onLayerAdd(){

        this.registerSourcheChangeEvent()

    }

    onLayerRemove(){

        // check if isochrone is active
        if(this.map.getLayers().getArray().filter(layer => layer.get('id') === "Isochronen").length == 0){

            this.isoChroneActive = false
        }

        if(this.isoChroneActive == false){
            this.$emit('update:isochroneFeature', undefined)

            this.deactivateSourceChangeEvent()

            this.map.getLayers().un('add', this.onLayerAdd)
            this.map.getLayers().un('remove', this.onLayerRemove)


        }
        else{
            this.init()
        }
    }


    registerSourcheChangeEvent(){

        for(let layer of this.map.getLayers().getArray()){

            let source = (layer as ol_layer.Layer).getSource()

            source.on("change", this.init)
        }

        

    }

    deactivateSourceChangeEvent(){
        for(let layer of this.map.getLayers().getArray()){

            let source = (layer as ol_layer.Layer).getSource()

            source.un("change", this.init)
        }
    }

    init(){

        this.isoChroneActive = true

        this.resultset =  new MapQueryResultSet()

        
        for (let layer of this.map.getLayers().getArray()) {

            let showLegend:boolean = true
            let showIsochroneInfopanel:boolean = true

            if (layer.get('showLegend') != undefined) {
                showLegend = layer.get('showLegend')
            }
            if(layer.get('showIsochroneInfoPanel')==false){
                showIsochroneInfopanel = false
            }

            if(showLegend && showIsochroneInfopanel){

                let source:any = (layer as ol_layer.Layer).getSource()


                // workaoround bc instace of ol.Vector doesnt work and heatmap is a wms layer source.getFormat != undefined
                if(source.getFormat != undefined){
                
                    let features = (source as ol_source.Vector).getFeatures()


                for(let feature of features){

                    let geom:any = feature.getGeometry()


                    if(geom == undefined){
                        continue
                    }
                    
                    let coords:any = geom.getCoordinates()

                    if(geom.getType()=='Point' && this.isochroneFeature.getGeometry()?.intersectsCoordinate(coords)){

                        this.addFeature(feature as ol.Feature, layer as ol_layer.Layer)
                    }
                    
                }
                }
                
            }
        }    
    }

    addFeature(feature: FeatureLike, layer: ol_layer.Layer) {

        if (layer == null) {
            console.log("FeatureInfoTool: Layer is null");
            return
        }

        //############### BEGIN Handle cluster layer features ###############
        if (feature.getProperties().features instanceof Array) {

            for (let f2 of feature.getProperties().features) {
                // TODO: 3 Replace this with getClusteredFeaturesRecursive()
                this.addFeature(f2, layer)
            }

            return
        }
        //############### END Handle cluster layer features ###############

        //################ BEGIN Exclude features based on layer settings ###############
        // TODO: 4 Maybe move this to the layerFilter argument? (see below)
        if (layer.get("showFeatureInfo") == false) {
            //console.log(layer.get('title') + ": Layer is configured to not be included in feature info.")
            return
        }

        if (!layer.getVisible()) {
            return
        }
        //################ END Exclude features based on layer settings ###############
        this.resultset.add(feature as ol.Feature, layer as ol_layer.Layer)

    }

}
